<template>
  <!-- หัวข้อและปุ่มเพิ่มลายสัก -->
    <div v-if="isAdmin" class="flex bg-gray-900 p-1 justify-between items-center ">
      <h2 class="text-2xl font-bold text-indigo-300">ห้องสัก</h2>
      <button
        
        @click="toggleCreateModal = true"
        class="bg-green-600 hover:bg-green-700 text-white py-2 px-5 rounded-lg transition-all duration-200 flex items-center gap-2 shadow-md hover:shadow-lg"
      >
        <i class="fas fa-plus text-sm"></i> เพิ่มลายสัก
      </button>
    </div>

    <!-- ข้อมูลเงินและ Filter -->
  
    <div >
      <div class="flex flex-wrap gap-3 justify-center p-2 bg-gray-900">
        <button
          v-for="filter in filters"
          :key="filter.value"
          @click="selectFilter(filter.value)"
          :class="[
            'p-1 rounded-lg text-xs sm:text-sm font-semibold transition-all duration-200 shadow-sm',
            selectedFilter === filter.value ? 'bg-indigo-700 text-white' : 'bg-gray-700 hover:bg-gray-600 text-gray-100'
          ]"
        >
          {{ filter.label }}
        </button>
      </div>
    </div>
  <div class="p-4 pb-24 bg mb-auto h-full overflow-auto bg-gradient-to-b from-gray-800 text-white backdrop-blur-sm" id="style-1">
  

    <!-- รายการลายสัก (Card Grid) -->
    <div v-if="!loading" class="rounded-lg overflow-hidden">
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        <div
          v-for="tattoo in tattoos"
          :key="tattoo.id"
          class="p-3 rounded-lg text-sm transition-all duration-200 flex flex-col bg-opacity-80 relative shadow-md hover:shadow-lg"
          :class="[
            tattooNames.includes(tattoo.name) ? 'bg-red-900 border border-red-600 cursor-not-allowed' : 'bg-gray-900 border border-gray-700 hover:bg-gray-800 hover:border-indigo-500 cursor-pointer'
          ]"
        >
          <div @click="openConfirmModal(tattoo)" class="w-full flex flex-col">
            <img
              :src="tattoo.imageUrl || 'https://via.placeholder.com/150'"
              alt="Tattoo"
              class="w-full h-40 rounded-md object-cover mb-3"
            />
            <span class="font-semibold text-center text-gray-100 mb-2 text-base">{{ tattoo.name }}</span>
            <div class="flex flex-col gap-1 text-gray-100 mb-2 text-center font-bold">
              <span v-if="tattoo.levelRequired > 0" class="text-yellow-400 text-sm">เลเวลขั้นต่ำ: {{ tattoo.levelRequired }}</span>
              <span v-if="tattoo.stats.str > 0" class="text-sm">STR +{{ tattoo.stats.str }}</span>
              <span v-if="tattoo.stats.stamina > 0" class="text-sm">STAMINA +{{ tattoo.stats.stamina }}</span>
              <span v-if="tattoo.stats.int > 0" class="text-sm">INT +{{ tattoo.stats.int }}</span>
              <span v-if="tattoo.stats.agi > 0" class="text-sm">AGI +{{ tattoo.stats.agi }}</span>
              <span v-if="tattoo.stats.luck > 0" class="text-sm">LUCK +{{ tattoo.stats.luck }}</span>
            </div>
            <!-- ตารางแสดงราคา -->
            <div class="flex flex-col gap-1 text-sm">
              <span
                v-if="tattoo.cost.silver > 0"
                class="flex items-center justify-between px-2 py-1 bg-gray-700 bg-opacity-20 rounded"
              >
                <span>{{ formatNumber(tattoo.cost.silver) }}</span>
                <i class="fas fa-coins text-gray-300"></i>
              </span>
              <span
                v-if="tattoo.cost.gold > 0"
                class="flex items-center justify-between px-2 py-1 bg-yellow-700 bg-opacity-20 rounded"
              >
                <span>{{ formatNumber(tattoo.cost.gold) }}</span>
                <i class="fas fa-g text-yellow-500"></i>
              </span>
              <span
                v-if="tattoo.cost.diamond > 0"
                class="flex items-center justify-between px-2 py-1 bg-blue-700 bg-opacity-20 rounded"
              >
                <span>{{ formatNumber(tattoo.cost.diamond) }}</span>
                <i class="fas fa-gem text-blue-500"></i>
              </span>
              <span
                v-if="tattoo.cost.cash > 0"
                class="flex items-center justify-between px-2 py-1 bg-green-700 bg-opacity-20 rounded"
              >
                <span>{{ formatNumber(tattoo.cost.cash) }}</span>
                <i class="fas fa-money-bill text-green-500"></i>
              </span>
            </div>
          </div>
          <div v-if="isAdmin && !tattooNames.includes(tattoo.name)" class="absolute top-3 right-3 flex gap-2">
            <button
              @click.stop="openEditModal(tattoo)"
              class="bg-blue-600 hover:bg-blue-700 text-white rounded-full p-2.5 transition-all duration-200"
              title="แก้ไขลายสัก"
            >
              <i class="fas fa-edit text-sm"></i>
            </button>
            <button
              @click.stop="deleteTattoo(tattoo)"
              class="bg-red-600 hover:bg-red-700 text-white rounded-full p-2.5 transition-all duration-200"
              title="ลบลายสัก"
              :disabled="isDeleting"
            >
              <i v-if="!isDeleting" class="fas fa-trash text-sm"></i>
              <div v-else class="animate-spin-pulse rounded-full h-5 w-5 border-t-2 border-white"></div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal สร้างลายสัก -->
    <CreateTattooModal
      v-if="isAdmin"
      :is-open="toggleCreateModal"
      @close="toggleCreateModal = false"
      @tattoo-created="fetchTattoos"
    />

    <!-- Modal แก้ไขลายสัก -->
    <EditTattooModal
      v-if="isAdmin"
      :is-open="toggleEditModal"
      :tattoo="selectedTattoo"
      @close="toggleEditModal = false"
      @tattoo-updated="fetchTattoos"
    />

    <!-- Modal ยืนยันการสัก -->
    <ConfirmTattooModal
      :is-open="toggleConfirmModal"
      :tattoo="selectedTattoo"
      @close="toggleConfirmModal = false"
      @tattoo-confirmed="handleTattooConfirmed"
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { projectFirestore } from '@/firebase/config';
import getUser from '@/composables/getUser';
import { usePlayerStore } from '@/composables/usePlayerStore';
import CreateTattooModal from '../components/admin/CreateTattooModal.vue';
import EditTattooModal from '../components/admin/EditTattooModal.vue';
import ConfirmTattooModal from '../components/ConfirmTattooModal.vue';

export default {
  name: 'TattooShop',
  components: { CreateTattooModal, EditTattooModal, ConfirmTattooModal },
  setup() {
    const { user } = getUser();
    const playerStore = usePlayerStore();
    const tattoos = ref([]);
    const userCash = ref(0);
    const tattooNames = ref([]);
    const loading = ref(true);
    const toggleCreateModal = ref(false);
    const toggleEditModal = ref(false);
    const toggleConfirmModal = ref(false);
    const selectedTattoo = ref(null);
    const selectedFilter = ref('str');
    const isAdmin = ref(false);
    const isDeleting = ref(false);
    const error = ref('');

    const filters = ref([
      { value: 'str', label: 'STR' },
      { value: 'stamina', label: 'Stamina' },
      { value: 'int', label: 'INT' },
      { value: 'agi', label: 'AGI' },
      { value: 'luck', label: 'LUCK' }
    ]);

    const formatNumber = (number) => {
      if (typeof number !== 'number' || isNaN(number)) return '0';
      return number.toLocaleString('en-US');
    };

    watch(() => playerStore.userData, (data) => {
      if (data) {
        userCash.value = data.cash || 0;
        isAdmin.value = data.admin || false;
      }
    }, { immediate: true });

    watch(() => playerStore.characterPrivateData, (data) => {
      if (data) {
        tattooNames.value = data.tattooNames || [];
      }
    }, { immediate: true });

    const fetchData = async () => {
      if (!user.value) {
        loading.value = false;
        return;
      }

      try {
        await fetchTattoos();
      } catch (err) {
        console.error('Error fetching data:', err);
        error.value = 'เกิดข้อผิดพลาดในการโหลดข้อมูล';
      } finally {
        loading.value = false;
      }
    };

    const fetchTattoos = async () => {
      try {
        loading.value = true;
        const snapshot = await projectFirestore
          .collection('tattoos')
          .where('type', '==', selectedFilter.value)
          .orderBy('order', 'asc')
          .get();
        tattoos.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      } catch (err) {
        console.error('Error fetching tattoos:', err);
        error.value = 'เกิดข้อผิดพลาดในการโหลดลายสัก';
      } finally {
        loading.value = false;
      }
    };

    const selectFilter = async (filterValue) => {
      selectedFilter.value = filterValue;
      await fetchTattoos();
    };

    const openConfirmModal = (tattoo) => {
      if (!tattooNames.value.includes(tattoo.name)) {
        selectedTattoo.value = tattoo;
        toggleConfirmModal.value = true;
      }
    };

    const openEditModal = (tattoo) => {
      selectedTattoo.value = tattoo;
      toggleEditModal.value = true;
    };

    const deleteTattoo = async (tattoo) => {
      if (!confirm(`คุณแน่ใจหรือไม่ว่าต้องการลบลายสัก "${tattoo.name}"?`)) {
        return;
      }

      isDeleting.value = true;
      error.value = '';
      try {
        await projectFirestore.collection('tattoos').doc(tattoo.id).delete();
        await fetchTattoos();
      } catch (err) {
        console.error('Error deleting tattoo:', err);
        error.value = 'เกิดข้อผิดพลาดในการลบลายสัก';
      } finally {
        isDeleting.value = false;
      }
    };

    const handleTattooConfirmed = (tattooName, newBalances) => {
      userCash.value = newBalances.cash;
      tattooNames.value.push(tattooName);
      toggleConfirmModal.value = false;
      selectedTattoo.value = null;
    };

    watch(toggleConfirmModal, (newValue) => {
      console.log('toggleConfirmModal changed:', newValue);
      console.log('selectedTattoo:', selectedTattoo.value);
    });

    onMounted(() => {
      if (user.value?.uid) {
        playerStore.init(user.value.uid);
      }
      fetchData();
    });

    return {
      tattoos,
      userCash,
      tattooNames,
      loading,
      toggleCreateModal,
      toggleEditModal,
      toggleConfirmModal,
      selectedTattoo,
      selectedFilter,
      filters,
      isAdmin,
      isDeleting,
      error,
      fetchTattoos,
      selectFilter,
      openConfirmModal,
      openEditModal,
      deleteTattoo,
      handleTattooConfirmed,
      formatNumber
    };
  }
};
</script>

<style scoped>
#style-1 {
  scrollbar-width: thin;
  scrollbar-color: #4a5568 #2d3748;
}

#style-1::-webkit-scrollbar {
  width: 6px;
}

#style-1::-webkit-scrollbar-track {
  background: #2d3748;
  border-radius: 10px;
}

#style-1::-webkit-scrollbar-thumb {
  background: #4a5568;
  border-radius: 10px;
}

#style-1::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.animate-spin-pulse {
  animation: spin-pulse 1.2s ease-in-out infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes spin-pulse {
  0% { transform: rotate(0deg) scale(1); }
  50% { transform: rotate(180deg) scale(1.2); }
  100% { transform: rotate(360deg) scale(1); }
}

button:not(:disabled):active {
  transform: scale(0.98);
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.bg {
  background: url('https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/bg%2Ftattooshop.png?alt=media&token=9019f20b-38e8-4b54-bf3f-35ff7abbf770') no-repeat center center fixed,
              linear-gradient(to bottom, rgba(31, 41, 55, 0.8), rgba(0, 0, 0, 0.9));
  background-size: cover;
}
</style>